import { toast } from "react-toastify";

/** @type {{ broadcastListId: string, processedRecords: number, numberOfRecords: number, finished: boolean, responsibleForExecution: string }[]} */
const INITIAL_STATE = [];

export default function broadcastListReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@BROADCAST_LIST/UPDATE_PROGRESS_IMPORT': {
      const { payload } = action;
      if (!payload || !payload.broadcastListId) {
        return state;
      }

      if (payload.finished) {
        if (payload.responsibleForExecution === localStorage.getItem("login")) {
          toast.success(`A importação de contatos foi concluída. ${payload.numberOfRecords} contatos importados.`, { autoClose: false, closeOnClick: true })
        }
        return []
      }

      const broadcastListIndex = state.findIndex(bl => bl.broadcastListId === payload.broadcastListId);

      if (broadcastListIndex !== -1) {
        return state.map((item, index) =>
          index === broadcastListIndex
            ? { ...item, ...payload }
            : item
        );
      } else {
        return [...state, payload];
      }
    }

    default:
      return state;
  }
}
